import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import Spinner from 'react-bootstrap/Spinner';

import { useAuth } from '../contexts/AuthContext';

interface SuperAdminRouteProps
{
    children: React.ReactNode;
}

const SuperAdminRoute: React.FC<SuperAdminRouteProps> = ({ children }) =>
{
    const { user, loading } = useAuth();
    const location = useLocation();

    if (loading)
    {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
                <Spinner animation="border" role="status">
                    <span className="visually-hidden">Loading...</span>
                </Spinner>
            </div>
        );
    }

    const isSuperAdmin = user && /superadmin/i.test(user.role);

    if (!isSuperAdmin)
    {
        return <Navigate to={user ? '/' : '/login'} state={{ from: location }} replace />;
    }

    return <>{children}</>;
};

export default SuperAdminRoute;